import Big, { BigSource } from 'big.js'
import { Offer } from 'src/common/types/models/Offer'
import { safeDiv, ZERO } from '../big-utils'
import { DotcEnums } from 'src/common/contracts/enums/dotc'

enum CalcOfferMode {
  In,
  Out,
}
export const calcOfferPrice = (offer: Offer, mode = CalcOfferMode.Out) =>
  mode === CalcOfferMode.Out
    ? safeDiv(offer.amountIn, offer.amountOut)
    : safeDiv(offer.amountOut, offer.amountIn)

export const calcAvgOffersPrice = (offers?: Offer[]) => {
  if (!offers?.length) return ZERO
  return offers
    .reduce((acc, offer) => acc.add(calcOfferPrice(offer)), ZERO)
    .div(offers.length)
}

export const calcEquivalentTargetAsset = (
  sellAmount: BigSource,
  pricePerUnitSell: BigSource,
  pricePerUnitTarget: BigSource
): Big => {
  const totalValueInUSD = Big(sellAmount).mul(Big(pricePerUnitSell))
  const equivalentTargetAmount = totalValueInUSD.div(pricePerUnitTarget)

  return equivalentTargetAmount
}

export const calcDynamicOfferAmountOut = (
  sellAmount: BigSource,
  percentage: BigSource | null,
  percentageType: DotcEnums.PercentageType | null,
  depositAssetPrice: BigSource,
  withdrawalAssetPrice: BigSource
): Big => {
  // Calculate the base price per unit before applying any percentage adjustments

  let amountOut = calcEquivalentTargetAsset(
    sellAmount,
    depositAssetPrice,
    withdrawalAssetPrice
  )

  if (percentage && percentageType) {
    const adjustment = amountOut.mul(Big(percentage)).div(100)

    if (percentageType === DotcEnums.PercentageType.Plus) {
      amountOut = amountOut.plus(adjustment)
    } else if (percentageType === DotcEnums.PercentageType.Minus) {
      amountOut = amountOut.minus(adjustment)
    }
  }
  return amountOut
}

export function calcPercentageDifference(
  pricePerUnit: Big,
  marketPrice: Big
): Big {
  if (marketPrice.eq(0)) {
    return ZERO
  }

  const difference = pricePerUnit.minus(marketPrice).div(marketPrice).times(100)
  return difference
}
